<script>
	import Swal from "sweetalert2";

	async function showSuccessModal(message = "Sua requisição foi enviada.", title = "Sucesso") {
		return Swal({
			title,
			text: message,
			type: "success",
			confirmButtonClass: "md-button md-success",
			buttonsStyling: false,
			animation: false
		});
	}

	async function showSuccessPinModal(message, title = "Sucesso") {
		return Swal({
			title,
			text: message,
			type: "success",
			confirmButtonClass: "md-button md-success",
			buttonsStyling: false,
			animation: false
		});
	}

	async function showLoadingModal(promise, message = "Aguarde até o final.", title = "Enviando", errorMessage = "Não foi possível carregar.", errorHandler = null) {
		let result;
		return Swal({
			title,
			text: message,
			onBeforeOpen: async () => {
    			Swal.showLoading();
				try {
					result = await promise;
					console.log('loading modal result', result);
					Swal.hideLoading();
					Swal.clickConfirm();
				} catch (err) {
					//console.log(err);
					if (errorHandler) {
						errorHandler(err);
					} else {
						this.showFailModal(errorMessage);
					}
				}
			},
			preConfirm: () => {
				return result;
			},
			animation: false,
			allowOutsideClick: () => !Swal.isLoading(),
		});
	}

	async function showWarningModal(message = "Cuidado", title = "Aviso") {
		return Swal({
			title,
			text: message,
			type: "warning",
			confirmButtonClass: "md-button md-warning",
		});
	}

	async function showFailModal(message = "Houve uma falha ao processar sua requisição", title = "Erro", errorHandler) {
		return Swal({
			title,
			text: message,
			type: 'error',
			confirmButtonClass: 'md-button md-danger',
			buttonsStyling: false,
			animation: false
		}).then(result => {
			if (errorHandler) errorHandler(result);
		});
	}

	async function showConfirmationModal(text1 = 'Tem certeza?', text2 = 'Não é possível reverter a operação!') {
		return Swal({
			title: text1,
			text: text2,
			type: 'warning',
			animation: false,
			showCancelButton: true,
			confirmButtonText: 'Enviar',
			cancelButtonText: 'Cancelar',
			confirmButtonClass: 'md-button md-success',
			cancelButtonClass: 'md-button md-danger',
			buttonsStyling: false
		});
	}

	async function showLgpdConfirmationModal(text1 = 'Tem certeza?', text2 = 'Não é possível reverter a operação!') {
		return Swal({
			title: text1,
			text: text2,
			type: 'warning',
			animation: false,
			showCancelButton: true,
			confirmButtonText: 'Anonimizar',
			cancelButtonText: 'Cancelar',
			confirmButtonClass: 'md-button md-success',
			cancelButtonClass: 'md-button md-danger',
			buttonsStyling: false
		});
	}

	function executeAsync(asyncFunction, successMessage, errorMessage, errorHandler) {
		asyncFunction()
			.then(() => {
				if (successMessage) {
					return showSuccessModal(successMessage);
				}
			})
			.catch(error => {
				if (errorHandler) {
					return errorHandler(error);
				}

				if (error.error === "ERR_BAD_REQUEST" && error.errorDetails) {
					return showFailModal(`Erro de validação: ${error.errorDetails}`);
				}

				if (error.error === "ERR_DUPLICATE") {
					return showFailModal(`Campos duplicados não permitidos.`);
				}

				switch(error.message) {
					case "MISSING_FIELDS":
						return showFailModal("Preencha os campos obrigatórios");
					case "CANCELLED":
						return showFailModal("A requisição foi cancelada", "Cancelado");
					case "NOT_ALLOWED":
						return showFailModal("Operação não permitida");
					case "ERR_DUPLICATE":
						return showFailModal("Registro já cadastrado");
				}

				if(error.message.indexOf("ERR_API_COMPANY_CNPJ_EXISTS_") != -1) {
					return showFailModal(error.message.replace("ERR_API_COMPANY_CNPJ_EXISTS_",""));
				}

				console.error(error);

				if (errorMessage) {
					return showFailModal(errorMessage);
				}
			});
	}

	async function readFileAsText(file) {
		return new Promise((resolve, reject) => {
			const reader = new FileReader();

			reader.onload = (event) => resolve(event.target.result);
			reader.onabort = () => reject(Error("ERR_FILE_READ"));
			reader.onerror = (event) => reader.abort();

			reader.readAsText(file);
		});
	}

	export default {
		showSuccessModal,
		showSuccessPinModal,
		showLoadingModal,
		showWarningModal,
		showFailModal,
		showConfirmationModal,
		showLgpdConfirmationModal,
		executeAsync,
		readFileAsText,
	}
</script>
